module.exports = __webpack_public_path__ + "img/UI_SSL_yuanbao_06_8dce5069a.png";